import React from 'react'

import { Box } from '@chakra-ui/react'

export type CloseIconProps = {
  size?: number
  color?: string
  colorScheme?: string
}

export const CloseIcon = ({
  size = 14,
  color,
  colorScheme,
}: CloseIconProps) => (
  <Box
    alignItems='center'
    color={
      color ??
      (colorScheme === 'light' ? 'light.icon.secondary' : 'icon.secondary')
    }
    display='flex'
    flexShrink={0}
    height={`${size}px`}
    lineHeight={0}
    width={`${size}px`}
  >
    <svg
      fill='none'
      height={size}
      viewBox='0 0 14 14'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <line
        stroke='currentColor'
        strokeLinecap='round'
        strokeWidth='1.5'
        x1='1'
        x2='13'
        y1='1'
        y2='13'
      />
      <line
        stroke='currentColor'
        strokeLinecap='round'
        strokeWidth='1.5'
        x1='13'
        x2='1'
        y1='1'
        y2='13'
      />
    </svg>
  </Box>
)
